import PartyService from '@/services/party.service.js'
const actions = {
    async fetchParties({ dispatch }) {
        try {
          const response = await PartyService.fetchParties()
            const data = response.payload.responseData || response.payload || response
            return data
        } catch (error) {
          dispatch(
            'notification/showError',
            error.message || 'Failed to load accounting years',
            { root: true }
          )
          throw error
        }
      }
}
export default {
   namespaced: true,
   actions
}
